import {
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  VStack,
} from "@chakra-ui/react";
import { Controller, useWatch } from "react-hook-form";
import { ChoiceStack } from "../../../components/Form";
import { QuestionBox } from "./questionBox";
import { ExtraNote } from "./extraNote";
import { regexNoEmptyString } from "../../../util/regex";

export function MultiSelectQuestion({
  question,
  index,
  errors,
  control,
  skipQuestion,
  register,
}) {
  const { _id: questionId, questionText, extraNote, choices } = question;
  const name = `${questionId}.selectedMultiChoices`;
  const error = errors[questionId]?.selectedMultiChoices;

  const hasChoiceDescriptionErrors = errors[questionId]?.choiceDescriptions
    ? Object.keys(errors[questionId]?.choiceDescriptions).length > 0
    : false;

  return (
    <FormControl isInvalid={error} isDisabled={skipQuestion}>
      <FormLabel>{`${question.order }. Soru${
        skipQuestion ? " (Bu soruyu atlayabilirsiniz.)" : ""
      }`}</FormLabel>
      <QuestionBox questionText={questionText} skipQuestion={skipQuestion} />
      <Controller
        name={name}
        control={control}
        render={({ field: { ref, ...rest } }) => (
          <CheckboxGroup {...rest}>
            <ChoiceStack error={error || hasChoiceDescriptionErrors}>
              {choices.map((choice) => {
                const { _id: choiceId, choiceText } = choice;
                const choiceDescriptionError =
                  errors[questionId]?.choiceDescriptions?.[choiceId];

                return (
                  <VStack key={choiceId} align={"flex-start"} spacing={1}>
                    <Checkbox value={choiceId}>{choiceText}</Checkbox>
                    {choice.descriptionText && (
                      <ChoiceDescriptionInput
                        questionId={questionId}
                        choiceId={choiceId}
                        descriptionText={choice.descriptionText}
                        choiceDescriptionError={choiceDescriptionError}
                        skipQuestion={skipQuestion}
                        register={register}
                        control={control}
                      />
                    )}
                  </VStack>
                );
              })}
            </ChoiceStack>
          </CheckboxGroup>
        )}
        rules={{
          validate: (value) =>
            skipQuestion
              ? true
              : !value || value?.length === 0
              ? "Gerekli alan"
              : true,
        }}
      />

      {extraNote && <ExtraNote extraNote={extraNote} />}

      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}

function ChoiceDescriptionInput({
  questionId,
  choiceId,
  descriptionText,
  choiceDescriptionError,
  skipQuestion,
  register,
  control,
}) {
  const questionWatch = useWatch({
    control,
    name: questionId,
  });
  const selectedMultiChoices = questionWatch?.selectedMultiChoices;

  const isDisabled =
    skipQuestion ||
    !selectedMultiChoices?.length || // undefined or nothing selected
    !selectedMultiChoices?.includes(choiceId); // not one of the selected choices

  return (
    <FormControl isInvalid={choiceDescriptionError} isDisabled={isDisabled}>
      <Input
        size={"sm"}
        variant={"filled"}
        errorBorderColor="#E53E3E"
        borderRadius={"md"}
        placeholder={descriptionText}
        _placeholder={{ opacity: 1, color: "gray.700" }}
        {...register(`${questionId}.choiceDescriptions.${choiceId}`, {
          validate: (value) => {
            if (selectedMultiChoices?.includes(choiceId)) {
              return !value // if value is undefined
                ? "Gerekli alan"
                : value.match(regexNoEmptyString) // check for empty string
                ? true
                : "Gerekli alan";
            } else {
              return true; // if choice is not selected
            }
          },
        })}
      />
      <FormErrorMessage>{choiceDescriptionError?.message}</FormErrorMessage>
    </FormControl>
  );
}
